import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "./ui/dropdown-menu";
import { LANGUAGES, localizePath, splitLangPath } from "../i18n/core";
import { useI18n } from "../i18n/I18nProvider";
import { PROMPT_DONE_KEY } from "./LanguagePrompt";

export default function LanguageSelector({ testIdPrefix = "lang", className = "" }) {
  const { lang, t } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();

  const switchTo = (code) => {
    localStorage.setItem(PROMPT_DONE_KEY, "1");
    const { basePath } = splitLangPath(location.pathname);
    navigate(localizePath(basePath, code) + location.search);
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        data-testid={`${testIdPrefix}-selector-trigger`}
        aria-label={t("language")}
        className={`flex items-center gap-1.5 text-[13px] tracking-[0.22em] uppercase text-[#1A1A1A] hover:text-[#C5A880] transition-colors duration-300 outline-none ${className}`}
      >
        <Globe className="w-3.5 h-3.5" strokeWidth={1.5} />
        <span data-testid={`${testIdPrefix}-current`}>{lang}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="rounded-none border border-[#E5DFD5] bg-[#F9F6F0] p-2 w-[300px] grid grid-cols-2 gap-x-1"
      >
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onSelect={() => switchTo(l.code)}
            data-testid={`${testIdPrefix}-option-${l.code}`}
            className={`rounded-none cursor-pointer px-3 py-2 text-[13px] focus:bg-[#EFE9DC] flex items-center justify-between ${
              l.code === lang ? "text-[#C5A880]" : "text-[#1A1A1A]"
            }`}
          >
            <span>{l.name}</span>
            {l.code === lang ? (
              <Check className="w-3 h-3" strokeWidth={1.5} />
            ) : (
              <span className="text-[9px] tracking-[0.2em] uppercase text-[#A8A39A]">{l.code}</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
